export const RESET_PATCH_MENU = 'RESET_PATCH_MENU';
export const PRE_RESET_PATCH_MENU = 'PRE_RESET_PATCH_MENU';
export const NEW_CLIENT = 'NEW_CLIENT';
export const DEPLOY_PATCH_MENU = 'DEPLOY_PATCH_MENU';
export const PRE_DEPLOY_PATCH_MENU = 'PRE_DEPLOY_PATCH_MENU';
export const DELETE_PATCH_MENU = 'DELETE_PATCH_MENU';
export const LAST_PATCH_MENUS_GET = 'LAST_PATCH_MENUS_GET';
export const LAST_PATCH_MENUS_SUCCESS = 'LAST_PATCH_MENUS_SUCCESS';
export const LAST_PATCH_MENUS_BY_CHILD_GET = 'LAST_PATCH_MENUS_BY_CHILD_GET';
export const LAST_PATCH_MENUS_BY_CHILD_SUCCESS =
	'LAST_PATCH_MENUS_BY_CHILD_SUCCESS';
export const PATCH_MENU_CONTENT_GET = 'PATCH_MENU_CONTENT_GET';
export const PATCH_MENU_CONTENT_SUCCESS = 'PATCH_MENU_CONTENT_SUCCESS';
export const MERGE_RULES_CHILDREN_GET = 'MERGE_RULES_CHILDREN_GET';
export const MERGE_RULES_CHILDREN_SUCCESS = 'MERGE_RULES_CHILDREN_SUCCESS';
export const MERGE_RULE_UPDATE = 'MERGE_RULE_UPDATE';
export const CASH_PERMISSIONS_GET = 'CASH_PERMISSIONS_GET';
export const CASH_PERMISSIONS_SUCCESS = 'CASH_PERMISSIONS_SUCCESS';
export const CASH_PERMISSION_UPDATE = 'CASH_PERMISSION_UPDATE';
export const MERGE_CONFIG_COPY = 'MERGE_CONFIG_COPY';
export const CASH_RESTRICTIONS_COPY = 'CASH_RESTRICTIONS_COPY';
export const CONFIG_LOG_GET = 'CONFIG_LOG_GET';
export const CONFIG_LOG_SUCCESS = 'CONFIG_LOG_SUCCESS';
export const STASH_LIST_GET = 'STASH_LIST_GET';
export const STASH_LIST_SUCCESS = 'STASH_LIST_SUCCESS';
export const STASH_UNAVAILABLE = 'STASH_UNAVAILABLE';
export const STASH_CREATE = 'STASH_CREATE';
export const STASH_RESTORE = 'STASH_RESTORE';
export const STASH_DELETE = 'STASH_DELETE';
export const STASH_CONTENT_GET = 'STASH_CONTENT_GET';
export const STASH_CONTENT_SUCCESS = 'STASH_CONTENT_SUCCESS';
export const STASH_CONTENT_EXPORT = 'STASH_CONTENT_EXPORT';
export const PATCH_MENU_CONTENT_EXPORT = 'PATCH_MENU_CONTENT_EXPORT';
export const PATCH_DATE_UPDATE = 'PATCH_DATE_UPDATE';
export const PATCH_CANCEL = 'PATCH_CANCEL';
export const CHILD_REFS_ANALYSE = 'CHILD_REFS_ANALYSE';
export const CHILD_REFS_SUCCESS = 'CHILD_REFS_SUCCESS';
export const CHILD_REFS_RESET = 'CHILD_REFS_RESET';
export const CHILD_REFS_IMPORT = 'CHILD_REFS_IMPORT';
// « Supprimer (sites) » : modifications en cours des établissements choisis.
export const CHILDREN_RESET = 'CHILDREN_RESET';
export const CHILDREN_RESET_SUCCESS = 'CHILDREN_RESET_SUCCESS';
export const CHILDREN_RESET_CLEAR = 'CHILDREN_RESET_CLEAR';
// Le temps de la question « surcharges aussi ? », la fenêtre n'est plus occupée.
export const CHILDREN_RESET_IDLE = 'CHILDREN_RESET_IDLE';
export const CHILDREN_RESET_BUSY = 'CHILDREN_RESET_BUSY';
export const PLACE_SEND_MAPPING_GET = 'PLACE_SEND_MAPPING_GET';
export const PLACE_SEND_MAPPING_SUCCESS = 'PLACE_SEND_MAPPING_SUCCESS';
export const PLACE_SEND_MAPPING_SET = 'PLACE_SEND_MAPPING_SET';
export const PLACE_SEND_MAPPING_DELETE = 'PLACE_SEND_MAPPING_DELETE';
